import { Navigate, Outlet } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'
import { ROUTES } from '../../utils/constants'

export const Protected = () => {
  const currentUser = useSelector(selectCurrentUser)

  if (currentUser) {
    return <Outlet />
  } else {
    return <Navigate to={ROUTES.MAIN} />
  }
}
